import React, { useState } from "react";
import LayerAdmin from "../LayerAdmin";
import { toast } from "react-toastify";
import ButtonLoader from "../../zamzam/components/ButtonLoader";
import { useNavigate } from "react-router-dom";
import URL_MAPPING from "../../../routes/constants";
import { addNewMonthly, addroadnet } from "../api/monthly";

const RoadnetSync = () => {
  const [formData, setFormData] = useState({
    session_description: "",

    territory_identifiers: "",
    regions: "",
  });

  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState<any>(new Date());
  const [endDate, setEndDate] = useState<any>(new Date());
  const [timeFrame, setSelectTimeFrame] = useState<any>("Today");
  const [invalidFields, setInvalidFields] = useState<string[]>([]);

  function formatDate(inputdate: any) {
    const date = new Date(inputdate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
  const checkTimeFrame = (start: any, end: any) => {
    if (start === formatDate(new Date()) && end === formatDate(new Date())) {
      setSelectTimeFrame("Today");
    } else if (
      start === formatDate(new Date().setDate(new Date().getDate() - 1)) &&
      end === formatDate(new Date().setDate(new Date().getDate() - 1))
    ) {
      setSelectTimeFrame("Yesterday");
    } else if (
      start === formatDate(new Date().setDate(1)) &&
      end === formatDate(new Date())
    ) {
      setSelectTimeFrame("Month till date");
    } else {
      setSelectTimeFrame("");
    }
  };

  const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setStartDate(e.target.value);
    checkTimeFrame(e.target.value, endDate);
  };

  const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEndDate(e.target.value);
    checkTimeFrame(startDate, e.target.value);
  };
  const formattedToday = formatDate(startDate);
  const navigate = useNavigate();

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const getInputClass = (field: string) =>
    `w-full border px-3 py-2 rounded ${
      invalidFields.includes(field) ? "border-red-500" : ""
    }`;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // const payload = {
    //   session_description: formData.session_description,

    //   territory_identifiers: formData.territory_identifiers,
    //   regions: formData.regions,
    // };
    const payload = new FormData();
    payload.append("session_description", formData.session_description);
    payload.append("territory_identifiers", formData.territory_identifiers);
    payload.append("regions", formData.regions);

    try {
      setLoading(true);
      const emptyFields = Object.entries(formData)
        .filter(([_, value]) => value === null || value === "")
        .map(([key]) => key);

      setInvalidFields(emptyFields);

      if (emptyFields.length > 0) {
        toast.error("Please fill all required fields.");
        return;
      }
      const response = await addroadnet(payload);
      if (!response) {
        toast.error("No data received or malformed response");
        console.warn("No data received or malformed response:", response);
        return;
      }
      toast.success(response?.message);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error: any) {
      console.error("Failed to fetch territory data:", error,{
        autoClose: false,
        closeOnClick: true,
        draggable: true,
      });
      if (error?.response?.status === 404) {
        toast.error(" Please try again later");
      } else if (error?.response?.status === 500) {
        toast.error("Error while fetching the territory",{
          autoClose: false,
          closeOnClick: true,
          draggable: true,
        });
      } else {
        const detail = error?.response?.data?.detail;
        if (Array.isArray(detail)) {
          detail.forEach((err) => toast.error(err.msg,{
            autoClose: false,
            closeOnClick: true,
            draggable: true,
          }));
        } else {
          toast.error(detail?.msg || detail || "An unexpected error occurred.",{
            autoClose: false,
            closeOnClick: true,
            draggable: true,
          });
        }
      }
    } finally {
      setLoading(false);
    }
  };
  return (
    <LayerAdmin>
      <div className="flex items-center px-5 pt-5 gap-3">
        <h3 className="text-xl font-bold text-gray-700">Roadnet Sync</h3>
      </div>
      <form onSubmit={handleSubmit} className="p-4 lg:w-1/3 sm:w-full">
        <div className="my-2">
          <label className="block font-semibold mb-1">
            Session Description *
          </label>
          <input
            type="text"
            name="session_description"
            value={formData.session_description}
            onChange={handleChange}
            className={getInputClass("session_description")}
            placeholder="Session Description"
          />
        </div>

        <div className="my-2">
          <label className="block font-semibold mb-1">
            Territory Identifiers
          </label>
          <input
            type="text"
            name="territory_identifiers"
            value={formData.territory_identifiers}
            onChange={handleChange}
            className={getInputClass("territory_identifiers")}
            placeholder="Territory Identifier"
          />
        </div>
        <div className="my-2">
          <label className="block font-semibold mb-1">Regions</label>
          <input
            type="text"
            name="regions"
            value={formData.regions}
            onChange={handleChange}
            className={getInputClass("regions")}
            placeholder=" Regions"
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className="bg-teal-500 text-white px-6 py-2 rounded hover:bg-teal-600 flex items-center gap-2"
        >
          Submit {loading && <ButtonLoader />}
        </button>
      </form>
    </LayerAdmin>
  );
};

export default RoadnetSync;
